"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableResponseTapePreviewJobs = exports.Preview = exports.CreditFacility = exports.receivableRetroEvent = exports.ReceivableStatus = void 0;
var ReceivableStatus;
(function (ReceivableStatus) {
    ReceivableStatus["Assigned"] = "assigned";
    ReceivableStatus["Unassigned"] = "unassigned";
    ReceivableStatus["Transferred"] = "transferred";
})(ReceivableStatus = exports.ReceivableStatus || (exports.ReceivableStatus = {}));
exports.receivableRetroEvent = [
    'retro-originate',
    'retro-assign',
    'retro-unassign',
];
const receivableNominalEvent = [
    'originate',
    'assign',
    'unassign',
    'transfer',
];
var CreditFacility;
(function (CreditFacility) {
    CreditFacility.ValuationBaseFieldsIterable = { valuation: 'valuation', valuationRate: 'valuationRate' };
    CreditFacility.EligibilityBaseFieldsIterable = {
        eligibleExposure: 'eligibleExposure',
        isEligible: 'isEligible',
        eligibilityKickout: 'eligibilityKickout',
    };
    CreditFacility.ConcentrationLimitBaseFieldsIterable = {
        eligibleExposureLessConcentrationLimitKickouts: 'eligibleExposureLessConcentrationLimitKickouts',
    };
    CreditFacility.BorrowingBaseBaseFieldsIterable = {
        borrowingBaseAmount: 'borrowingBaseAmount',
        advanceRate: 'advanceRate',
        advanceRatePath: 'advanceRatePath',
    };
    CreditFacility.LoanTapeMetadataPrimitiveProperties = [
        'reportingDate',
        'fileVersion',
        'commitmentAmount',
        'drawRequestAmountForCalendarMonth',
        'principalBalance',
        'lastApprovedOrSubmittedFundingRequestDate',
    ];
    CreditFacility.StaticLoanTapeMetadataProperties = [
        ...CreditFacility.LoanTapeMetadataPrimitiveProperties,
        'configuredActiveWaivers',
    ];
    CreditFacility.DynamicLoanTapeMetadataProperties = [
        'portfolioCovenants',
    ];
    CreditFacility.LoanTapeMetadataIterable = [
        ...CreditFacility.StaticLoanTapeMetadataProperties,
        ...CreditFacility.DynamicLoanTapeMetadataProperties,
    ];
})(CreditFacility = exports.CreditFacility || (exports.CreditFacility = {}));
var Preview;
(function (Preview) {
    let ReceivableResponseTapePreviewStatus;
    (function (ReceivableResponseTapePreviewStatus) {
        ReceivableResponseTapePreviewStatus["Completed"] = "completed";
        ReceivableResponseTapePreviewStatus["Failed"] = "failed";
        ReceivableResponseTapePreviewStatus["Initiated"] = "initiated";
        ReceivableResponseTapePreviewStatus["Started"] = "started";
    })(ReceivableResponseTapePreviewStatus = Preview.ReceivableResponseTapePreviewStatus || (Preview.ReceivableResponseTapePreviewStatus = {}));
})(Preview = exports.Preview || (exports.Preview = {}));
var ReceivableResponseTapePreviewJobs;
(function (ReceivableResponseTapePreviewJobs) {
    ReceivableResponseTapePreviewJobs.terminalStatuses = [
        'completed',
        'error',
    ];
    ReceivableResponseTapePreviewJobs.statuses = [
        'inProgress',
        ...ReceivableResponseTapePreviewJobs.terminalStatuses,
    ];
    ReceivableResponseTapePreviewJobs.assignmentMethod = ['csv', 'strategy', 'assignNone'];
    ReceivableResponseTapePreviewJobs.defaultPreviewEmailStatus = [
        'none',
        'generating',
        'notIncludedInEmail',
        'includedInEmail',
    ];
})(ReceivableResponseTapePreviewJobs = exports.ReceivableResponseTapePreviewJobs || (exports.ReceivableResponseTapePreviewJobs = {}));
//# sourceMappingURL=Receivable.js.map